import { Chip, MenuItem, MenuItemProps } from "@mui/material";
import './GGMenuItem.scss'

interface GGMenuItemProps extends MenuItemProps {
    showNewBadge?: boolean
    onClick?: (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
}

const GGMenuItem = (props: GGMenuItemProps)=>{
    const { showNewBadge, ...rest } = props;
    return(
        <div className="menu-item-container">
            <MenuItem className="mui-menu-item" {...rest}>
            {rest.children}
            {showNewBadge && (<Chip className="chip" label="New"></Chip>)}
            </MenuItem>
        </div>
    )
};

export default GGMenuItem